'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _geojsonBuilder = require('./geojsonBuilder.service');

var _geojsonBuilder2 = _interopRequireDefault(_geojsonBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var geojsonBuilderModule = _angular2.default.module('geojsonBuilder.service', []).service('GeojsonBuilder', _geojsonBuilder2.default).name;

exports.default = geojsonBuilderModule;


// WEBPACK FOOTER //
// ./client/app/services/geojsonBuilder/geojsonBuilder.js